import { useEffect, useState } from "react";
import axiosClientFSR from "../../../../services/axiosClientFSR";

const useFetchLocation = (
  path1,
  path2,
  isGroup,
  params = {},
  isApply,
  isFilter,
  reGetData
) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState();
  const {
    value,
    groupCam,
    provinceCode,
    districtCode,
    communeCode,
    haveVideo,
    isRecord,
    isVideoAI,
    serviceCode,
    type,
    aiConfig
  } = params;
  useEffect(() => {
    if (!isApply) {
      setIsLoading(true);
      const isAI =
        type === "AI"
          ? { ai_already: haveVideo ? haveVideo : null }
          : {
            ai_already: isVideoAI ? 1 : 0,
          };
      const isAiOn = aiConfig ? {
        ai_config: 1
      } : {}
      async function getData() {
        try {
          let path = isGroup ? path1 : path2;
          const res = await axiosClientFSR.get(path, {
            params: {
              warehouse_name: value,
              group_name: groupCam,
              province_code: provinceCode,
              district_code: districtCode,
              commune_code: communeCode,
              record_already: isRecord ? haveVideo : null,
              ...isAI,
              ...isAiOn,
              ai_service_code: serviceCode,
            },
          });
          setData(res);
          setIsLoading(false);
        } catch (error) {
          setStatus(error.response.status);
          setIsLoading(false);
        }
      }
      getData();
    }
  }, [
    isGroup,
    isApply,
    isFilter,
    value,
    groupCam,
    provinceCode,
    reGetData,
    path1,
    path2,
    haveVideo,
    isRecord,
    isVideoAI,
    serviceCode,
  ]);
  return { data, isLoading, status };
};
export default useFetchLocation;
